import { Grid } from '@material-ui/core'
import React, { useEffect } from 'react'
import CardWithChart from '../../components/CardWithChart'
import DoubleBarChart from '../../components/Charts/DoubleBarChart'
import MultipleLineChart from '../../components/Charts/MultipleLineChart'
import SingleBarGraph from '../../components/Charts/SingleBarGraph'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import { useDashBoard } from '../../hooks/DashBoard/useDashBoard'

export default function SalesDashboard() {
  const { getSalesDashBoard, salesDashBoard } = useDashBoard()
  useEffect(() => {
    getSalesDashBoard()
  }, [])
  return (
    <Layout heading="Sales Dashboard">
      {!salesDashBoard ? (
        <Loader />
      ) : (
        <Grid container>
          <Grid item lg={6}>
            <CardWithChart heading="Target Acheived Quarterly">
              <DoubleBarChart target={salesDashBoard.quarterWiseTarget} sales={salesDashBoard.quarterWiseSales} />
            </CardWithChart>
          </Grid>
          <Grid item lg={6}>
            <CardWithChart heading="Primary Sales">
              <MultipleLineChart
                currentYear={salesDashBoard.currentYearSale}
                previousYear={salesDashBoard.previousYearSale}
              />
            </CardWithChart>
          </Grid>
          <Grid item lg={12}>
            <CardWithChart heading="Incentive Earning">
              <SingleBarGraph schemeEarning={salesDashBoard.quarterWiseSchemeEarning} />
            </CardWithChart>
          </Grid>
        </Grid>
      )}
    </Layout>
  )
}
